<template lang="pug">

div

    p.ui.info.message(v-show="priceModels.length === 0") Noch keine Angebote vorhanden

    offer-table(
        v-show="priceModels.length > 0"
        v-bind:price-models="priceModels"
        v-bind:product-model="productModel"
    )

</template>


<script>
    import * as R from 'ramda'
    import store from '@/store'
    import * as PriceUtils from '@/utils/price'
    import OfferTable from '@/components/products/offers/Table'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            const productId = R.prop('id', to.params)
            const variantId = R.prop('variantId', to.params)

            await Promise.all([

                // Produkt laden
                store.dispatch('products/loadOne', { id: productId }),

                // Variant laden
                store.dispatch('variants/loadOne', { id: variantId }),

                // Variant laden
                store.dispatch('offers/loadAllByVariantId', { variantId }),

                // Preise laden
                store.dispatch('prices/loadAllByVariantId', { variantId, params: { isPublished: true } })

            ])

            next()
        },

        components: { OfferTable },

        computed: {

            productId() {
                return R.pipe(R.prop('id'), Number)(this.$route.params)
            },

            productModel() {
                return store.getters['products/byId'](this.productId)
            },

            priceModels() {
                return R.compose(

                    // Preise sortieren
                    PriceUtils.sort_by_printing_and_unit_price,

                    // Preise holen
                    store.getters['prices/allByVariantIdAndIsPublished'],

                )(this.variantId)
            },

            variantId() {
                return R.pipe(R.prop('variantId'), Number)(this.$route.params)
            },

            variantModel() {
                return store.getters['variants/byId'](this.variantId)
            },

        },

        watch: {

            '$route.params.variantId'(variantId) {
                // Preise laden
                store.dispatch('prices/loadAllByVariantId', { variantId, params: { isPublished: true } })
            }

        }

    }

</script>
